import axios from 'axios';

export const UPLOAD_FILE_SUCCESS = 'UPLOAD_FILE_SUCCESS';
export const UPLOAD_FILE_FAIL = 'UPLOAD_FILE_FAIL';


export const uploadFile = (formData) => async (dispatch) => {
  try {
    const response = await axios.post('/api/files/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    dispatch({
      type: UPLOAD_FILE_SUCCESS,
      payload: response.data, // Contains the uploaded file URL
    });

    return response.data; // Return data to update container state
  } catch (error) {
    dispatch({
      type: UPLOAD_FILE_FAIL,
      payload: error.response?.data?.message || 'File upload failed',
    });

    throw error; // Throw error to handle in the container
  }
};

